import type { CarAd } from "@mobility-item-page/types";

type CarTaxonomyExtracted = {
  make: string;
  series?: string;
  model: string;
};

export const extractCarTaxonomy = (data?: CarAd["car_model_taxonomy"]): CarTaxonomyExtracted | undefined => {
  if (!data?.parent) {
    return undefined;
  }
  if (data.parent.parent) {
    // e.g., Audi > A3 > Sportback
    return {
      make: data.parent.parent.value,
      series: data.parent.value,
      model: data.value,
    };
  } else {
    // e.g., Tesla > Model 3
    return {
      make: data.parent.value,
      model: data.value,
    };
  }
};
